export default function defineApiUrl(env) {
  if (env === 'prod') {
    return 'https://api.pointreg.ru/'
  } else {
    return process.env.VUE_APP_API_HOST
  }
}
